module.exports = __webpack_public_path__ + "img/first-section.a8fb6a55.png";